export const X_HOHR_CAPTCHA_TOKEN = "x-hohr-captcha-token";